import React from 'react';
import { Typography } from '@mui/material';
//
import ObAlert from '@components/ObAlert';
import { FormikContext } from '@components/formik';

const Summary = () => {
  const [ownerErr, setOwnerErr] = React.useState(false);
  const [businessErr, setBusinessErr] = React.useState(false);
  const [publicErr, setPublicErr] = React.useState(false);
  const [payoutErr, setPayoutErr] = React.useState(false);
  const [twoFaErr, settwoFaErr] = React.useState(false);
  const [taxErr, setTaxErr] = React.useState(false);

  const { steps, currentStep, setCurrentStep } =
    React.useContext(FormikContext);

  // Handle step change
  const handleStep = (step: number, subStep: number) => {
    setCurrentStep({ step, subStep });
  };

  React.useEffect(() => {
    // Reset errors
    setOwnerErr(false);
    setBusinessErr(false);
    setPublicErr(false);
    setPayoutErr(false);
    settwoFaErr(false);
    setTaxErr(false);

    // Check for owner errors
    // @ts-ignore
    if (steps[0]?.subSteps[1]?.isCompleted === false) {
      setOwnerErr(true);
    }

    // Check for business errors
    // @ts-ignore
    if (steps[0]?.subSteps[2]?.isCompleted === false) {
      setBusinessErr(true);
    }

    // Check for public errors
    // @ts-ignore
    if (steps[0]?.subSteps[3]?.isCompleted === false) {
      setPublicErr(true);
    }

    // Check for payout errors
    // @ts-ignore
    if (steps[1]?.subSteps[0]?.isCompleted === false) {
      setPayoutErr(true);
    }

    // Check for two-factor errors
    // @ts-ignore
    if (steps[2]?.subSteps[0]?.isCompleted === false) {
      settwoFaErr(true);
    }

    // Check for tax errors
    // @ts-ignore
    if (steps[3]?.subSteps[0]?.isCompleted === false) {
      setTaxErr(true);
    }
  }, [steps]);

  // console.log(steps);

  return (
    <>
      <Typography variant="h4" component="h2" gutterBottom>
        Agree and Submit
      </Typography>
      <Typography variant="body1" mb={4} color="text.secondary">
        You’re almost ready to start exploring Paybilt. Take a moment to review
        and confirm your information.
      </Typography>

      <ObAlert
        title="Management And Ownership"
        type={ownerErr ? 'error' : 'success'}
        onClick={() => handleStep(0, 1)}
      >
        <Typography color="text.primary" fontWeight={500}>
          {ownerErr ? 'Missing required information' : 'Owner information'}
        </Typography>
      </ObAlert>

      <ObAlert
        title="Business Details"
        type={businessErr ? 'error' : 'success'}
        onClick={() => handleStep(0, 2)}
      >
        <Typography color="text.primary" fontWeight={500}>
          {businessErr
            ? 'Missing business information'
            : 'Business information'}
        </Typography>
      </ObAlert>

      <ObAlert
        title="Public Details"
        type={publicErr ? 'error' : 'success'}
        onClick={() => handleStep(0, 3)}
      >
        <Typography color="text.primary" fontWeight={500}>
          {publicErr ? 'Missing public information' : 'Public information'}
        </Typography>
      </ObAlert>

      <ObAlert
        title="Payout details"
        type={payoutErr ? 'error' : 'success'}
        onClick={() => handleStep(1, 0)}
      >
        <Typography color="text.primary" fontWeight={500}>
          {payoutErr ? 'Missing payout information' : 'Payout information'}
        </Typography>
        <Typography color="text.secondary">
          Add a bank account where you'll receive your payouts.
        </Typography>
      </ObAlert>

      {/* <ObAlert
        title="Two-step authentication"
        type={twoFaErr ? 'error' : 'success'}
        onClick={() => handleStep(2, 0)}
      >
        <Typography color="text.primary" fontWeight={500}>
          {twoFaErr
            ? 'Two-step authentication is not enabled'
            : 'Two-step authentication'}
        </Typography>
        <Typography color="text.secondary">
          Set up two-factor authentication to protect your account.
        </Typography>
      </ObAlert> */}

      {/* <ObAlert
        title="Tax Calculation"
        type={taxErr ? 'info' : 'success'}
        onClick={() => handleStep(2, 0)}
      >
        <Typography color="text.primary" fontWeight={500}>
          Automatic tax calculation
        </Typography>
        <Typography color="text.secondary">{taxErr ? 'Off' : 'On'}</Typography>
      </ObAlert> */}
    </>
  );
};

export default Summary;
